import { render } from "./TableauDeBord.vue?vue&type=template&id=0498ad0d&scoped=true"
import script from "./TableauDeBord.vue?vue&type=script&lang=js"
export * from "./TableauDeBord.vue?vue&type=script&lang=js"

import "./TableauDeBord.vue?vue&type=style&index=0&id=0498ad0d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0498ad0d"]])

export default __exports__